import HTTPUrlHelper from "shared/helpers/HTTPUrlHelper";
import { actionCoreApi } from "core/utils/api";
import ActionsList from "core/actions/Actions.list";
import { ActionType } from "core/utils/interfaces";
import { getValueFromState } from '../../shared/helpers/utils'

/**
 * Validates a redirect URL to prevent open-redirect and javascript: URI XSS attacks.
 * Only allows relative paths (starting with '/') or absolute https URLs
 * pointing to the same origin. Blocks javascript:, data:, vbscript:, and
 * any other non-HTTP schemes.
 */
export const isSafeRedirectUrl = (url: string): boolean => {
  if (!url || url.trim() === '') return false;
  const trimmed = url.trim();

  // Block obvious dangerous schemes early (case-insensitive)
  if (/^javascript:/i.test(trimmed) ||
      /^data:/i.test(trimmed) ||
      /^vbscript:/i.test(trimmed)) {
    return false;
  }

  // Block control characters and backslashes often used in URL obfuscation
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001F\u007F\\]/.test(trimmed)) {
    return false;
  }

  // Allow relative paths (e.g. /account/accounts)
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
    return true;
  }

  // Allow only https absolute URLs
  try {
    const parsed = new URL(trimmed);
    return parsed.protocol === 'https:';
  } catch (_e) {
    return false;
  }
}

export const verify  = (userName: string, state: string, locale: string,  key: string) : void => {
  fetch(HTTPUrlHelper.verifyUserNameAPI(userName.includes('+') ? userName.replace('+', encodeURIComponent('+')) : userName, state, locale, key), {
    method: 'get' 
}).then(response => {
             const contentType = response.headers.get("content-type");
             if (contentType && contentType.indexOf("application/json") !== -1) {
               return response.json().then(data => {
                 if (isSafeRedirectUrl(data)) {
                   window.location.href = data
                 } else {
                   console.error('Blocked unsafe redirect (JSON path):', data)
                 }
               });
             } else {
               const stateDecoded = atob(state)
               const rawRedirectUri = getValueFromState("returnPath=", stateDecoded)
               let redirectUri: string
               try {
                 redirectUri = decodeURIComponent(rawRedirectUri)
               } catch (_e) {
                 redirectUri = rawRedirectUri
               }
               if (isSafeRedirectUrl(redirectUri)) {
                 window.location.href = redirectUri
               } else {
                 console.error('Blocked unsafe redirect (state path):', redirectUri)
               }
             }
           });
}

export const fetchCustomLoginSettings = (): ActionType =>
actionCoreApi(
  ActionsList.UserNameExists,
  HTTPUrlHelper.fetchCustomLoginSettings(),
  'GET'
)
